import { useCallback, useRef } from "react";
import { shouldReIdentify } from "@utils";
import { setLDClient } from "../../../utils/helpers/ldClient";

const useLaunchDarklyIdentification = (ldClient, user, pathAccountId, location) => {
  const identifying = useRef(false);

  return useCallback(async () => {
    const currentContext = ldClient.getContext();
    const reIdentify = shouldReIdentify(currentContext, user);

    if (reIdentify && !identifying.current) {
      try {
        identifying.current = true;
        const userContext = {
          key: user.sub,
          kind: "user",
          email: user.email,
          name: user.name || "",
          custom: {
            userId: user.sub,
            accountId: pathAccountId,
            assistantId: location?.pathname?.split("/")?.[2],
          }
        };
        await ldClient.identify(userContext);
        setLDClient(ldClient);
      } catch (error) {
        console.error("Failed to identify user in LaunchDarkly:", error);
      } finally {
        identifying.current = false;
      }
    }
  }, [ldClient, user, pathAccountId, location]);
};

export default useLaunchDarklyIdentification;
